import { Locale } from '../../../i18n';

export const authButtonTranslation = {
  [Locale.en]: {
    signIn: 'Sign In',
    signOut: 'Sign Out',
  },
};
